export default __webpack_public_path__ + "static/hero-desktop-13f62172e0b86920751c124805ccba51.png";